import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  container: {
    height: 400,
    width: "100%",
  },
});
